import { useContext } from "react";
import CreditPeriodsContext from "./CreditPeriodsContext";

const useCreditPeriods = () => useContext(CreditPeriodsContext);

export default useCreditPeriods;
